(() => {
	angular.module('main').directive('subscriptionNavbar', subscriptionNavbar);

	subscriptionNavbar.$inject = [];

	function subscriptionNavbar() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./subscriptionNavbar.component.html'),
			controller: 'ClientNavbarControllerS',
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/subscriptionNavbar.component.js